/**
 * CareerAI の表示テキスト整形（Vue 非依存の純関数）。
 *
 * 吹き出しは `v-html` で描くので、**エスケープしてから**簡易マークダウンを当てる。
 * 順番を逆にすると本文中の `<` がタグとして解釈される。
 */

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;'
}

const escapeHtml = (str: unknown): string =>
  String(str).replace(/[&<>"']/g, (c) => ESCAPE_MAP[c])

/** 太字・インラインコード・リンク・箇条書きだけの簡易マークダウン */
export function renderMarkdown(text: unknown): string {
  if (!text) return ''
  let html = escapeHtml(text)
  html = html.replace(/\*\*([^*\n]+?)\*\*/g, '<strong>$1</strong>')
  html = html.replace(/`([^`\n]+?)`/g, '<code>$1</code>')
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener">$1</a>'
  )
  // 行頭 "- " / "* " を箇条書きマーカへ（簡易）
  html = html.replace(/(^|\n)[-*] (.+?)(?=\n|$)/g, '$1• $2')
  return html
}

/** チャット冒頭に出す日付（YYYY.MM.DD） */
export function formatChatDate(now: Date): string {
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}.${month}.${day}`
}
